import React from "react";

var Component = function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 23v-6a4 4 0 0 1 8 0v6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 21V10l11-9 11 9v11a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z"
  })));
};

Component.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
Component.displayName = "home";
export default Component;